import { generateIconComponent } from './icons.utils';

export const PointerLightIcon = generateIconComponent({
    name: 'PointerLightIcon',
    viewBox: '0 0 18 24',
    path: (
        <>
            <path d="M9 0C4.04326 0 0 4.11058 0 9.16683C0 14.2231 6.0574 24 9 24C11.7779 24 18 13.7426 18 9.16683C18 4.11058 13.9642 0 9 0ZM9 22.6578C7.40516 22.6578 1.31032 14.04 1.31032 9.1592C1.31032 4.84271 4.76206 1.32698 9 1.32698C13.2379 1.32698 16.6897 4.84271 16.6897 9.1592C16.6897 13.796 10.4376 22.6578 9 22.6578Z" />
            <path d="M9 5.17064C6.66389 5.17064 4.76955 7.10772 4.76955 9.4795C4.76955 11.8513 6.67138 13.7884 9 13.7884C11.3286 13.7884 13.2304 11.8513 13.2304 9.4795C13.2304 7.10772 11.3286 5.17064 9 5.17064ZM9 12.4538C7.39018 12.4538 6.07987 11.1192 6.07987 9.4795C6.07987 7.83985 7.39018 6.50524 9 6.50524C10.6098 6.50524 11.9201 7.83985 11.9201 9.4795C11.9201 11.1192 10.6098 12.4538 9 12.4538Z" />
        </>
    ),
});
